import { httpClient } from '../client';
import { logger } from '../../../utils/logger';
import { BaseEndpoint } from './base.endpoint';
import { ApiErrorHandler } from '../error.handler';
import { EmailSettings, EmailSettingsApiResponse } from '../../../types/email-settings';

class EmailSettingsEndpoints extends BaseEndpoint {
  private static instance: EmailSettingsEndpoints;

  private constructor() {
    super('organisations');
  }

  static getInstance(): EmailSettingsEndpoints {
    if (!EmailSettingsEndpoints.instance) {
      EmailSettingsEndpoints.instance = new EmailSettingsEndpoints();
    }
    return EmailSettingsEndpoints.instance;
  }

  async getEmailSettings(organizationId: string) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.get<EmailSettingsApiResponse>(
        `${this.basePath}/${organizationId}/email-settings`,
        { headers }
      );

      logger.info('E-Mail settings fetched successfully');
      const data = response.data.data;
      return data;
    } catch (error) {
      logger.error('Failed to fetch E-Mail settings:', error);

      return ApiErrorHandler.handle(error);
    }
  }

  async createEmailSettings(organizationId: string, emailSettings: EmailSettings) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.post<EmailSettings>(
        `${this.basePath}/${organizationId}/email-settings`,
        emailSettings,
        { headers }
      );

      logger.info('E-Mail settings created successfully');
      return response.data;
    } catch (error) {
      logger.error('Failed to create E-Mail settings:', error);

      return ApiErrorHandler.handle(error);
    }
  }

  async updateEmailSettings(organizationId: string, emailSettings: EmailSettings) {
    try {
      const headers = await this.getAuthHeaders();
      const response = await httpClient.put<EmailSettings>(
        `${this.basePath}/${organizationId}/email-settings`,
        emailSettings,
        { headers }
      );

      logger.info('E-Mail settings updated successfully');
      return response.data;
    } catch (error) {
      logger.error('Failed to update E-Mail settings:', error);
      return ApiErrorHandler.handle(error);
    }
  }

  async deleteEmailSettings(organizationId: string) {
    try {
      const headers = await this.getAuthHeaders();
      await httpClient.delete(`${this.basePath}/${organizationId}/email-settings`, {
        headers,
      });

      logger.info('E-Mail settings deleted successfully');
    } catch (error) {
      logger.error('Failed to delete E-Mail settings:', error);

      return ApiErrorHandler.handle(error);
    }
  }
}

export const emailSettingsEndpoints = EmailSettingsEndpoints.getInstance();
